import { useMemo } from "react"
import symbolizeHotkey from "~/utils/symbolizeHotkey"

const useHotkeys = (shortcut) => {
  return useMemo(() => {
    return symbolizeHotkey(shortcut)
  }, [shortcut])
}
export default useHotkeys
